import { PUBLIC_API_KEY } from '$env/static/public';

/**
 * Crea un wrapper attorno a fetch che aggiunge automaticamente l'header X-API-Key.
 * Usa la factory quando hai bisogno di wrappare un fetch custom (es. quello di SvelteKit).
 * @param {typeof fetch} customFetch - Funzione fetch da wrappare (default: fetch globale)
 * @returns {typeof fetch} Fetch wrappato con X-API-Key
 */
export function createApiFetch(customFetch = fetch) {
    return (url, options = {}) => {
        const headers = {
            'X-API-Key': PUBLIC_API_KEY,
            ...options.headers,
        };

        return customFetch(url, {
            ...options,
            headers,
        });
    };
}

/**
 * Wrapper fetch preconfigurato con X-API-Key.
 * Usare al posto di fetch() per tutte le chiamate al backend.
 */
export const apiFetch = createApiFetch();
